import React from "react";

const CountryContext = React.createContext({
    numberOfCountries: "top",
    setNumberOfCountries: () => {}
});

export default CountryContext;